export const envsArray = [
  {
    url: 'http://dev.api.psychics247.com',
    logo: '/p247.png',
    name: 'Psychics24/7 dev'
  },
  {
    url: 'http://dev2.api.psychicdb.com',
    logo: '/tf.png',
    name: 'TarotFox dev'
  },
  {
    url: 'http://dev.api.mypsychic.com',
    logo: '/mp.jpg',
    name: 'MyPsychic dev'

  },
  {
    url: 'http://dev3.api.psychicdb.com',
    logo: '/tm.png',
    name: 'Tarot Mistico dev'
  },
  {
    url: 'http://dev2.api.psychicdb.com',
    logo: '/er.png',
    name: 'Expertos en Romance dev'
  },
  {
    url: 'https://dev.api.spiritspace.com',
    logo: '/ss.png',
    name: 'Spirit Space dev'
  },
  {
    url: 'https://dev.api.healingspace.com',
    logo: '/hs.png',
    name: 'Healing Space dev'
  },
  {
    url: 'http://localhost:4000',
    logo: '/localhost.png',
    name: 'Localhost'
  }
];



// WEBPACK FOOTER //
// ./src/config/config.dev.js